import { useSearchParams, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, XCircle, Users, ArrowLeft, Shield } from 'lucide-react';
import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { getFormattedDate, isPassDeadline } from '@/lib/date-manipulation';

// Mock data untuk demo - dalam implementasi nyata ini akan dari database
const mockMembers = {
  'SP001': {
    id: 'SP001',
    name: 'Ahmad Suryanto',
    position: 'Koordinator Divisi Produksi',
    memberSince: '2021-03-15',
    status: 'active',
    branch: 'Jakarta Timur'
  },
  'SP002': {
    id: 'SP002',
    name: 'Siti Rahayu',
    position: 'Sekretaris Umum',
    memberSince: '2020-08-10',
    status: 'active',
    branch: 'Jakarta Pusat'
  }
};

export default function Verification() {
  const [searchParams] = useSearchParams();
  const memberId = searchParams.get('id');
  
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`/cards/${memberId}`);
        setData(response.data?.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const isValid = !!data;
  // const isValid = !!data && isPassDeadline(data?.expired_at+'Z');

  console.log({isValid}, !!data , getFormattedDate(data?.expired_at+'Z'))
  
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b bg-card">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Link to="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Kembali
              </Button>
            </Link>
            <div className="flex items-center gap-2">
              <Shield className="h-6 w-6 text-primary" />
              <h1 className="text-xl font-bold">Validasi Keanggotaan</h1>
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <Card className="shadow-card-soft">
            <CardHeader className="text-center">
              <CardTitle className="flex items-center justify-center gap-3 text-2xl">
                {isValid ? (
                  <>
                    <CheckCircle className="h-8 w-8 text-green-600" />
                    Anggota Tervalidasi
                  </>
                ) : (
                  <>
                    <XCircle className="h-8 w-8 text-destructive" />
                    Validasi Gagal
                  </>
                )}
              </CardTitle>
            </CardHeader>

            <CardContent className="space-y-6">
              {isValid && data ? (
                <div className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-muted-foreground">
                        Nama Lengkap
                      </label>
                      <p className="text-lg font-semibold">{data?.name}</p>
                    </div>
                    
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-muted-foreground">
                        ID Anggota
                      </label>
                      <p className="text-lg font-mono">{data?.membership_id}</p>
                    </div>
                    
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-muted-foreground">
                        Jabatan
                      </label>
                      <p className="text-lg">{data?.position}</p>
                    </div>
                    
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-muted-foreground">
                        Cabang
                      </label>
                      <p className="text-lg">{data.puk?.name}</p>
                    </div>
                    
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-muted-foreground">
                        Anggota Sejak
                      </label>
                      <p className="text-lg">{new Date().toLocaleDateString('id-ID', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}</p>
                    </div>
                    
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-muted-foreground">
                        Status
                      </label>
                      <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                        <CheckCircle className="h-4 w-4" />
                        Aktif
                      </span>
                    </div>
                  </div>

                  <div className="bg-muted p-4 rounded-lg">
                    <div className="flex items-center gap-2 mb-2">
                      <Users className="h-5 w-5 text-primary" />
                      <h3 className="font-semibold">Informasi Validasi</h3>
                    </div>
                    <p className="text-sm text-muted-foreground">
                      Anggota ini telah tervalidasi sebagai bagian dari Serikat Pekerja 
                      dan memiliki hak penuh dalam organisasi. Validasi dilakukan pada{' '}
                      {new Date().toLocaleDateString('id-ID', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}.
                    </p>
                  </div>
                </div>
              ) : (
                <div className="text-center space-y-4">
                  <div className="bg-destructive/10 p-4 rounded-lg">
                    <p className="text-destructive font-medium">
                      {memberId ? 
                        'ID anggota tidak valid atau tidak ditemukan dalam sistem.' :
                        'QR Code tidak valid atau rusak.'
                      }
                    </p>
                    <p className="text-sm text-muted-foreground mt-2">
                      Silakan hubungi administrator untuk bantuan lebih lanjut.
                    </p>
                  </div>
                  
                  {memberId && (
                    <div className="text-left space-y-2">
                      <label className="text-sm font-medium text-muted-foreground">
                        ID yang dipindai
                      </label>
                      <p className="text-lg font-mono text-destructive">{memberId}</p>
                    </div>
                  )}
                </div>
              )}

              <div className="flex gap-3 pt-4">
                <Button asChild variant="outline" className="flex-1">
                  <Link to="/">
                    Kembali ke Beranda
                  </Link>
                </Button>
                {isValid && (
                  <Button variant="union" className="flex-1">
                    Cetak Hasil Validasi
                  </Button>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
}